export enum AnalyticsEventCategory {
  CORP_ADMIN_EMPLOYEE = 'corp admin_employee',
  CORP_ADMIN_LOCATION = 'corp admin_location',
  SELF_SERVICE_PEOPLE = 'self-service management tool_people',
  SELF_SERVICE_ORDER_HISTORY = 'self-service management tool_orderhistory',
  SELF_SERVICE_LOC = 'self-service management tool_loc',
  MEAL_CREDIT_SETTINGS = 'meal credit settings',
}

export enum AnalyticsEventAction {
  ADD_NEW_EMPLOYEE = 'add new employee',
  ADD_NEW_LOCATION = 'add new location',
  CREATE_GROUP_CTA = 'create group_cta',
  GROUPS_TAB_CTA = 'groups tab_cta',
  ADD_PEOPLE_TO_GROUP_CTA = 'add people to group_cta',
  ADD_PEOPLE_TO_GROUP_IMPRESSION = 'add people to group_impression',
  CREATE_GROUP_IMPRESSION = 'create group_impression',
  BULK_DOWNLOAD_RECEIPTS_CTA = 'bulk download receipts_cta',
  ADD_PEOPLE_MANUALLY = 'add people_manually',
  ADD_PEOPLE_UPLOAD_CSV = 'add people_upload csv',
  LOC_ADD_PEOPLE_MANUALLY = 'loc_add_people_manually',
  LOC_UPLOAD_CSV = 'loc_upload csv',
  LOC_SOFT_ADD_PEOPLE = 'loc_soft_add_people',
  SOFT_ADD_PEOPLE = 'soft add people',
  ASSIGN_GROUP_TO_MEAL_CREDIT_CTA = 'assign group to meal credit_cta',
  UPDATE_GROUP_CTA = 'update group_cta',
}
